module.exports = __webpack_public_path__ + "img/penang.05555a22.png";